import { atom, selector } from 'recoil';
import { UserInfoResponse } from '../../types/login.types';

export const userInfoState = atom<any>({
    key: 'userInfoState',
    default: <UserInfoResponse>{
        capabilities: {},
        matrixPar: {},
        userInfo: {}
    },
    effects: [
        ({ setSelf, onSet }) => {
            const stored = localStorage.getItem('userInfo');
            if (stored) {
                try {
                    setSelf(JSON.parse(stored));
                } catch {
                    // corrupted data → reset
                    localStorage.removeItem('userInfo');
                    setSelf({
                        capabilities: {},
                        matrixPar: {},
                        userInfo: {},
                    });
                }
            }

            onSet((value) => {
                localStorage.setItem('userInfo', JSON.stringify(value));
            });
        },
    ],
});
